module.exports = __webpack_public_path__ + "24e004ab/img/menu-icon.5f8facae.svg";